(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-300-gift-card-hero"] && !Shopify.designMode) return;
  try {
    
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { landing_page: '300-offer' } })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-flexible-plan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_TYPE = 'c-flexible-plan';

    function initSection(container) {
      const benefits = container.querySelectorAll('.c-flexible-plan__benefit');
      const slides = container.querySelectorAll('.c-flexible-plan__media-slide');
      const speed = (parseInt(container.dataset.autoplaySpeed, 10) || 5) * 1000;

      if (benefits.length === 0) return;

      let activeIndex = 0;
      let timer = null;

      function activate(index) {
        benefits.forEach(function (b) { b.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });

        if (benefits[index]) benefits[index].classList.add('is-active');
        if (slides[index]) slides[index].classList.add('is-active');

        activeIndex = index;
      }

      function next() {
        var nextIndex = (activeIndex + 1) % benefits.length;
        activate(nextIndex);
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(next, speed);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      benefits.forEach(function (benefit, idx) {
        benefit.addEventListener('click', function () {
          activate(idx);
          stopAutoplay();
          startAutoplay();
        });
      });

      startAutoplay();

      container._flexiblePlanCleanup = function () {
        stopAutoplay();
      };
    }

    function destroySection(container) {
      if (container._flexiblePlanCleanup) {
        container._flexiblePlanCleanup();
        delete container._flexiblePlanCleanup;
      }
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
      if (section) initSection(section);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
      if (section) destroySection(section);
    });

    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-value-props-49off"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-section-type="c-value-props-49off"]');
    sections.forEach(function (section) {
      if (section.dataset.cValueProps49offInit === '1') return;
      section.dataset.cValueProps49offInit = '1';

      var ACTIVE_CLASS = 'c-value-props-49off__benefit--active';
      var benefits = section.querySelectorAll('.c-value-props-49off__benefit');
      if (!benefits.length) return;

      var speedSec = parseFloat(section.dataset.autoplaySpeed || '0');
      var intervalMs = isNaN(speedSec) ? 0 : speedSec * 1000;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canAutoplay = intervalMs > 0 && !prefersReducedMotion;

      var activeIndex = 0;
      for (var i = 0; i < benefits.length; i++) {
        if (benefits[i].classList.contains(ACTIVE_CLASS)) {
          activeIndex = i;
          break;
        }
      }

      var timer = null;

      function setActive(index) {
        benefits.forEach(function (el, i) {
          var isActive = i === index;
          el.classList.toggle(ACTIVE_CLASS, isActive);
          el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        activeIndex = index;
      }

      function next() {
        setActive((activeIndex + 1) % benefits.length);
      }

      function startTimer() {
        if (!canAutoplay) return;
        stopTimer();
        timer = window.setInterval(next, intervalMs);
      }

      function stopTimer() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      // On click: activate clicked benefit and restart the timer immediately
      // (resets the cycle so the user gets a full interval to read it).
      benefits.forEach(function (el, i) {
        el.addEventListener('click', function () {
          setActive(i);
          startTimer();
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            setActive(i);
            startTimer();
          }
        });
      });

      setActive(activeIndex);
      startTimer();

      function cleanup() {
        stopTimer();
      }

      window.addEventListener('beforeunload', cleanup);
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target === section || section.contains(e.target)) cleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-slideshow-v-2-0"] && !Shopify.designMode) return;
  try {
    
  // Slideshow component
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.ss-slideshow__slide');
      if (this.slides.length <= 1) return;

      this.currentSlideIndicator = this.querySelector('.ss-current-slide-indicator');
      this.currentSlideIndex = this.dataset.activeSlide;
      this.counterControls = this.querySelectorAll('.ss-slideshow-controls__link');

      this.nextControl = this.querySelector('.ss-slideshow-control--next');
      this.previousControl = this.querySelector('.ss-slideshow-control--previous');

      if (this.getAttribute('data-autoplay') === 'true') {
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
        this.isAutoplayButtonSetToPlay = true;
        this.setAutoPlay();
      }

      this.initButtons();
    }

    initButtons() {
      this.nextControl.addEventListener('click', () => {
        this.updateSlideshow('next');
        this.resetAutoPlay();
      });

      this.previousControl.addEventListener('click', () => {
        this.updateSlideshow('previous');
        this.resetAutoPlay();
      });

      this.counterControls.forEach((control) => {
        control.addEventListener('click', () => {
          if (this.currentSlideIndex == control.dataset.slideNumber) return;
          this.updateSlideshow(control.dataset.slideNumber);
          this.resetAutoPlay();
        });
      });
    }

    updateSlideshow(target = 'next') {
      let nextSlideIndex = 0;
      let transitionDirection = target;

      switch (target) {
        case 'next':
          nextSlideIndex = parseInt(this.dataset.activeSlide) + 1;
          break;
        case 'previous':
          nextSlideIndex = parseInt(this.dataset.activeSlide) - 1;
          break;
        default:
          nextSlideIndex = target;
          transitionDirection = nextSlideIndex > this.dataset.activeSlide ? 'next' : 'previous';
          break;
      }

      if (nextSlideIndex < 0) {
        nextSlideIndex = this.slides.length - 1;
      } else if (nextSlideIndex >= this.slides.length) {
        nextSlideIndex = 0;
      }

      this.slideTransition(this.slides[this.dataset.activeSlide], this.slides[nextSlideIndex], transitionDirection);
      this.updateControls(nextSlideIndex);
      this.dataset.activeSlide = nextSlideIndex;
      this.currentSlideIndex = nextSlideIndex;
    }

    slideTransition(currentSlide, nextSlide, transitionDirection) {
      const slideshowControls = this.querySelectorAll('.ss-slideshow-control');
      slideshowControls.forEach((control) => {
        control.setAttribute('disabled', 'true');
      });

      currentSlide.addEventListener('animationend', (event) => {
        if (event.animationName.includes('ssSlideIn')) return;

        // Hide slides & reset transitions
        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.classList.remove(`ss-slide--transition-out-${transitionDirection}`);
        });

        // Set new slide to active
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.classList.remove(`ss-slide--${transitionDirection}`);
        slideshowControls.forEach((control) => {
          control.removeAttribute('disabled');
        });
      });

      // Start slide transition
      currentSlide.classList.add(`ss-slide--transition-out-${transitionDirection}`);
      nextSlide.classList.add(`ss-slide--${transitionDirection}`);
    }

    updateControls(newSlideIndex) {
      // If we have a current slide indicator (i.e. 2/3), update it
      if (this.currentSlideIndicator) {
        this.currentSlideIndicator.innerText = `${newSlideIndex + 1}/${this.slides.length}`;
        return;
      }

      this.counterControls.forEach((control) => {
        control.classList.remove('ss-slideshow-controls__link--active');
      });
      this.counterControls[newSlideIndex].classList.add('ss-slideshow-controls__link--active');
    }

    resetAutoPlay() {
      if (this.isAutoplayButtonSetToPlay) {
        this.play();
      }
    }

    /* Handle autoplay */
    setAutoPlay() {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.sliderAutoplayButton = this.querySelector('.ss-slideshow-control--autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.isAutoplayButtonSetToPlay = true;
      this.play();
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.isAutoplayButtonSetToPlay);
      this.isAutoplayButtonSetToPlay ? this.pause() : this.play();
      this.isAutoplayButtonSetToPlay = !this.isAutoplayButtonSetToPlay;
    }

    togglePlayButtonState(pauseAutoplay) {
      this.sliderAutoplayButton.classList.toggle('ss-slideshow-control--autoplay--paused', pauseAutoplay);
      pauseAutoplay
        ? this.sliderAutoplayButton.setAttribute('aria-label', 'Play slideshow')
        : this.sliderAutoplayButton.setAttribute('aria-label', 'Pause slideshow');
    }

    play() {
      this.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    autoRotateSlides() {
      this.updateSlideshow('next');
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay && !focusedOnAutoplayButton) this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay) {
        focusedOnAutoplayButton ? this.play() : this.pause();
      }
    }
  }

  if (!customElements.get('ss-slideshow-component')) {
    customElements.define('ss-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
